import {
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
  inject,
  input,
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { NbIconModule } from "@nebular/theme";
import { Course, EventFilter, EventLink } from "app/@core/types";
import { ActionPlanComponent } from "../action-plan/action-plan.component";
import { EventComponent } from "../event/event.component";
import { PeepsFindComponent } from "../peeps/peeps.component";

@Component({
  standalone: true,
  selector: "ngx-jumbotron",
  styleUrls: ["./jumbotron.component.scss"],
  templateUrl: "./jumbotron.component.html",
  imports: [
    RouterLink,
    NbIconModule,
    ActionPlanComponent,
    EventComponent,
    PeepsFindComponent,
  ],
})
export class JumbotronComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);

  course = input<Course>();
  isCommunity = input<boolean>(false);

  eventFilter: EventFilter = { key: 'upcoming', value: 1, limit: 1 };
  eventLink: EventLink = {
    text: "View all group sessions & recordings",
    color: "text-white",
  };
  basepath: string;

  ngOnInit() {
    this.basepath = this.course().slug == "aces" ? "/courses" : "/course";
    this.renderer.addClass(document.body, "has-jumbotron");
  }

  getFilter(key: string, value: any, limit: number, truncate: number) {
    return { key: key, value: value, limit: limit, truncate: truncate };
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, "has-jumbotron");
  }
}
